module.exports = __webpack_public_path__ + "img/bg_border.df76103a.png";